import React from 'react';
import './PageStyles.css';

function PrivacyPolicy() {
  return (
    <div className="page">
      <h1>🔒 Privacy Policy</h1>

      {/* 🔔 DISCLAIMER Added for Google Play Policy Compliance */}
      <p style={{ fontWeight: 'bold', backgroundColor: '#fff8e1', padding: '10px', border: '1px solid #ffc107', borderRadius: '6px' }}>
        📢 Disclaimer: TestYodha is not affiliated with any government agency. The information provided is for educational and informational purposes only.
      </p>

      <p>
        At <strong>TestYodha</strong>, your privacy is our responsibility. We are committed to protecting your personal information and being transparent about how we use it.
      </p>

      <h2>📌 What We Collect</h2>
      <ul style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
        <li>🧑 Name, email ID, and phone number</li>
        <li>📱 Limited device details to enhance learning experience</li>
        <li>📚 Test results and activity logs (for performance tracking)</li>
      </ul>

      <h2>✅ How We Use It</h2>
      <ul style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
        <li>To personalize your learning experience</li>
        <li>To improve app performance and content</li>
        <li>To provide accurate test analysis and recommendations</li>
      </ul>

      <h2>🛡️ We Never:</h2>
      <ul style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
        <li>❌ Sell or rent your data to anyone</li>
        <li>❌ Send unnecessary promotional emails</li>
        <li>❌ Track your personal activity outside the app</li>
      </ul>

      <h2>📍 Data Storage & Security</h2>
      <p>
        All data is securely stored on trusted cloud services with encryption. We follow standard practices to prevent unauthorized access, modification, or misuse of your information.
      </p>

      <h2>🇮🇳 Compliance</h2>
      <p>
        TestYodha complies with all applicable data protection laws in India, including IT Act Section 43A & 72A.
      </p>

      <hr style={{ margin: '40px auto', width: '60%', borderColor: '#444' }} />

      {/* 🔔 Repeated Disclaimer for Footer Visibility */}
      <p style={{ fontStyle: 'italic', color: '#25292e', marginBottom: '10px' }}>
        📢 Disclaimer: This app does not represent a government entity. All content is for educational purposes only.
      </p>

      <p style={{ fontStyle: 'italic', color: '#25292e' }}>
        If you have any questions about our privacy policy, feel free to contact us at  
        <a href="mailto:testyodha3@gmail.com" style={{ color: '#0047ab', textDecoration: 'none' }}> testyodha3@gmail.com</a>
      </p>
    </div>
  );
}

export default PrivacyPolicy;
